export default function (array, key) {
  let string = ''

  array.forEach(item => {
    string += ` ${item[key]}`
  })

  return string
}
